module.exports = __webpack_public_path__ + "static/media/Soul_Badge.7ccd9b5b.png";